// ##### Komarov 2025-07-25

const getAntdLocale = (lang) => {
  if (typeof window === 'undefined') return undefined;
  switch (lang) {
    case 'en':
      return require('antd/es/locale/en_US').default;
    case 'uk':
      return require('antd/es/locale/uk_UA').default;
    case 'tr':
      return require('antd/es/locale/tr_TR').default;
    case 'fr':
      return require('antd/es/locale/fr_FR').default;
    case 'ru':
      return require('antd/es/locale/ru_RU').default;
    default:
      return require('antd/es/locale/en_US').default;
  }
};

export { getAntdLocale };

export const dateLocales = {
  en: undefined,
  uk: undefined,
  tr: undefined,
  fr: undefined,
  ru: undefined,
};
